var _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFlightTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.137,27.062c-1.046,0-1.894-.848-1.894-1.894s.848-1.894,1.894-1.894h.657v-4.64h-.657c-1.046,0-1.894-.848-1.894-1.894s.848-1.894,1.894-1.894h.657v-3.61c0-.914-.741-1.656-1.656-1.656H4.861c-.914,0-1.656.741-1.656,1.656v19.53c0,.914.741,1.656,1.656,1.656h32.277c.914,0,1.656-.741,1.656-1.656v-3.704h-.657Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.143,
    y1: 9.579,
    x2: 32.143,
    y2: 32.421
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.635,29.198l.19-.172c.409-.371.615-.917.554-1.466l-.897-8.013,3.283-2.113c.595-.383,1.042-.958,1.266-1.63l.173-.518c.05-.15-.051-.307-.208-.323l-.543-.057c-.704-.074-1.412.095-2.008.478l-3.283,2.113-6.922-4.135c-.474-.283-1.056-.322-1.563-.103l-.236.102c-.176.076-.22.307-.083.441l3.965,3.901,1.21,2.13-3.708,2.387-2.767-.738c-.158-.042-.326-.016-.463.073l-.48.309c-.177.114-.171.374.011.48l2.387,1.385c.014.008.019.025.012.04l-.394.812c-.058.119.031.258.164.255l.902-.022c.016,0,.03.012.031.028l.272,2.746c.021.209.255.323.432.209l.48-.309c.137-.088.231-.231.258-.392l.474-2.825,3.708-2.387,1.438,1.983,1.909,5.224c.066.18.294.237.436.108Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFlightTicket);
export default __webpack_public_path__ + "static/media/indoor-flight_ticket.acb5b5ae01523d283f1a1a639e5df8df.svg";
export { ForwardRef as ReactComponent };